import api from '@/services/api'

const RESOURCE_URI = '/rent'

const fetchRents = () => api.get(RESOURCE_URI)
const fetchRentById = (id) => api.get(`${RESOURCE_URI}/${id}`)
const createRent = (rent) => api.post(RESOURCE_URI, rent)
const updateRent = ({
  id,
  toyId,
  periodId,
  customerId,
  userId,
  storeId,
  notes,
  status
}) =>
  api.put(`${RESOURCE_URI}/${id}`, {
    id,
    toyId,
    periodId,
    customerId,
    userId,
    storeId,
    notes,
    status
  })
const removeRent = (id) => api.delete(`${RESOURCE_URI}/${id}`)

const startRent = ({ toyId, periodId, storeId, customer }) =>
  api.post(`${RESOURCE_URI}/start`, {
    toyId,
    periodId,
    storeId,
    customer
  })

const pauseRent = ({ id }) => api.post(`${RESOURCE_URI}/${id}/pause`)

const resumeRent = ({ id }) => api.post(`${RESOURCE_URI}/${id}/resume`)

const closeRent = async ({
  id,
  checkoutId,
  payments,
  ignoreRentForPoint,
  status
}) => {
  if (!status || status !== 'paused') {
    const pauseResponse = await pauseRent({ id })
    if (pauseResponse.status !== 'paused')
      throw new Error('Erro ao pausar o aluguel.')
  }

  return api.post(`${RESOURCE_URI}/${id}/close`, {
    checkoutId,
    payments,
    ignoreRentForPoint
  })
}

const transferRent = ({ id, toyId }) =>
  api.post(`${RESOURCE_URI}/${id}/transfer`, { toyId })

const cancelRent = async ({ id, reason }) => {
  //Versão 2110-3.1, adicionado funcionalidade de pausar alugueis antes de cancelar (evitando informações de tempos incorretas para futuras recuperações de alugueis!)
  const cancelResponse = await api.post(`${RESOURCE_URI}/${id}/cancel`, {
    reason
  })
  return cancelResponse
}
const calculateRentAmount = async ({ rent, elapsedTime, hasProducts }) => {
  try {
    const response = await api.post(`${RESOURCE_URI}/calculateRentAmount`, {
      rent,
      elapsedTime,
      hasProducts
    })
    return response
  } catch (error) {
    console.error('Erro ao calcular o valor do aluguel:', error)
    throw error
  }
}
const addExtraTime = ({ id, time, reason }) =>
  api.post(`${RESOURCE_URI}/${id}/extra-time`, { time, reason })

const reopenLastRent = ({ id }) => api.post(`${RESOURCE_URI}/${id}/reopen`)

const changePeriod = ({ id, periodId }) =>
  api.post(`${RESOURCE_URI}/${id}/change-period`, { periodId })

const addProduct = ({ id, productId, quantity }) =>
  api.post(`${RESOURCE_URI}/${id}/product`, { productId, quantity })

const removeProduct = ({ id, productId }) =>
  api.delete(`${RESOURCE_URI}/${id}/product/${productId}`)

const rescueRent = ({ id }) => api.post(`${RESOURCE_URI}/${id}/rescue`)

export default {
  calculateRentAmount,
  fetchRents,
  fetchRentById,
  createRent,
  updateRent,
  removeRent,
  startRent,
  pauseRent,
  resumeRent,
  closeRent,
  transferRent,
  cancelRent,
  addExtraTime,
  reopenLastRent,
  rescueRent,
  changePeriod,
  addProduct,
  removeProduct
}
